interface Props {
  active: string;
  onChange: (sector: string) => void;
}

interface Group {
  label: string;
  value?: string;            // 그룹 헤더 자체가 필터값(주식/ETF). 없으면 비클릭
  items: string[];
}

export const GROUPS: Group[] = [
  { label: '주식', value: '주식', items: ['KOSPI', 'KOSDAQ'] },
  { label: 'ETF', value: 'ETF', items: ['국내지수', '섹터/테마', '해외주식', '원자재', '레버리지', '인버스'] },
  { label: '미국', value: '미국', items: [] },
];

// 🎨 규격 V2(08-23) — 파란 채움 대신 앰버 활성(오른쪽 2px 선 + 아주 옅은 앰버 바탕), 구획은 헤어라인.
const KICKER = 'text-[10.5px] font-[650] tracking-[.12em]';

export default function SectorSidebar({ active, onChange }: Props) {
  // 그룹 머리(주식·ETF)도 누르면 필터가 되는 자리라 버튼 그대로 두되, 글자는 섹션 라벨(키커) 모양으로.
  const Btn = ({ value, label, group }: { value: string; label: string; group?: boolean }) => (
    <button
      onClick={() => onChange(value)}
      className={`w-full text-left px-4 border-r-2 transition-colors ${
        group ? `${KICKER} pt-3.5 pb-2` : 'text-[13px] font-medium py-[7px]'
      } ${
        active === value
          ? 'bg-dc-point/[0.05] text-dc-ink1 font-bold border-dc-point'
          : 'text-dc-ink3 hover:text-dc-ink1 border-transparent'
      }`}
    >
      {label}
    </button>
  );

  return (
    <aside className="w-[150px] shrink-0 border-r border-dc-hair py-4 hidden md:block overflow-y-auto">
      <p className={`${KICKER} text-dc-ink3 px-4 pb-2`}>분류</p>
      <Btn value="전체" label="전체" />
      {GROUPS.map((g) => (
        <div key={g.label}>
          {g.value
            ? <Btn value={g.value} label={g.label} group />
            : <p className={`${KICKER} text-dc-ink3 px-4 pt-3.5 pb-2`}>{g.label}</p>}
          {g.items.map((it) => (
            <Btn key={it} value={it} label={it} />
          ))}
        </div>
      ))}
    </aside>
  );
}
